import { generateReference } from './formatters'

export const generateSeedData = () => {
  const now = new Date()

  const user = {
    id: 'usr_1',
    name: 'Tunde Adeleke',
    email: 'demo@billvast.com',
    phone: '+234 802 123 4567',
    walletBalance: 250000,
    avatar:
      'https://ui-avatars.com/api/?name=Tunde+Adeleke&background=73C883&color=fff',
  }

  const campaigns = [
    {
      id: 'camp_1',
      title: 'Medical Fund for Amara',
      description:
        'Help cover the surgery costs for Amara, a bright 10-year-old diagnosed with a rare heart condition. Every contribution brings her closer to a healthy life.',
      targetAmount: 750000,
      raisedAmount: 450000,
      category: 'Medical',
      endDate: new Date(now.getTime() + 15 * 24 * 60 * 60 * 1000).toISOString(),
      status: 'Active',
      imageUrl:
        'https://images.unsplash.com/photo-1584515933487-779824d29309?auto=format&fit=crop&q=80&w=400&h=250',
      createdAt: new Date(
        now.getTime() - 10 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      userId: 'usr_2',
      organizerName: 'Chioma Okafor',
    },
    {
      id: 'camp_2',
      title: 'Community Borehole Project',
      description:
        'Providing clean drinking water to the residents of Ikorodu. This project will build a central borehole to serve over 500 families.',
      targetAmount: 2000000,
      raisedAmount: 1200000,
      category: 'Community',
      endDate: new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000).toISOString(),
      status: 'Active',
      imageUrl:
        'https://images.unsplash.com/photo-1541976844346-f18aeac57b06?auto=format&fit=crop&q=80&w=400&h=250',
      createdAt: new Date(
        now.getTime() - 20 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      userId: 'usr_3',
      organizerName: 'Ikorodu Youth Forum',
    },
    {
      id: 'camp_3',
      title: 'School Supplies for Aba Kids',
      description:
        'Equipping 200 primary school students in Aba with backpacks, notebooks, and essential learning materials for the new academic year.',
      targetAmount: 500000,
      raisedAmount: 180000,
      category: 'Education',
      endDate: new Date(now.getTime() + 5 * 24 * 60 * 60 * 1000).toISOString(),
      status: 'Active',
      imageUrl:
        'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&q=80&w=400&h=250',
      createdAt: new Date(
        now.getTime() - 5 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      userId: 'usr_4',
      organizerName: 'Emeka Nwachukwu',
    },
    {
      id: 'camp_4',
      title: 'Tech Startup Seed Fund',
      description:
        'Raising initial capital for a local agritech startup helping farmers optimize crop yields using affordable IoT sensors.',
      targetAmount: 5000000,
      raisedAmount: 5000000,
      category: 'Business',
      endDate: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString(),
      status: 'Completed',
      imageUrl:
        'https://images.unsplash.com/photo-1556761175-5973dc0f32d7?auto=format&fit=crop&q=80&w=400&h=250',
      createdAt: new Date(
        now.getTime() - 60 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      userId: 'usr_5',
      organizerName: 'AgriTech Innovators',
    },
    {
      id: 'camp_5',
      title: 'My Tech Bootcamp Tuition',
      description:
        'Help me transition into tech! I need funds to pay for a 6-month intensive full-stack development bootcamp.',
      targetAmount: 300000,
      raisedAmount: 50000,
      category: 'Education',
      endDate: new Date(now.getTime() + 45 * 24 * 60 * 60 * 1000).toISOString(),
      status: 'Active',
      imageUrl:
        'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&q=80&w=400&h=250',
      createdAt: new Date(
        now.getTime() - 2 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      userId: 'usr_1',
      organizerName: 'Tunde Adeleke',
    },
  ]

  const transactions = [
    {
      id: 'tx_1',
      type: 'Wallet',
      title: 'Wallet Funding',
      amount: 100000,
      status: 'Completed',
      date: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
      reference: generateReference('FND'),
    },
    {
      id: 'tx_2',
      type: 'Bills',
      title: 'Ikeja Electric Prepaid',
      amount: -15000,
      status: 'Completed',
      date: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString(),
      reference: generateReference('BIL'),
    },
    {
      id: 'tx_3',
      type: 'Diaspora',
      title: 'Transfer to John Doe',
      amount: -77500, // $50 * 1550
      status: 'Completed',
      date: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000).toISOString(),
      reference: generateReference('TRF'),
    },
    {
      id: 'tx_4',
      type: 'Crowdfunding',
      title: 'Donation to Medical Fund',
      amount: -5000,
      status: 'Completed',
      date: new Date(now.getTime() - 8 * 24 * 60 * 60 * 1000).toISOString(),
      reference: generateReference('DON'),
    },
    {
      id: 'tx_5',
      type: 'Facility',
      title: 'Rent Payment - Ikota Villa',
      amount: -350000,
      status: 'Completed',
      date: new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000).toISOString(),
      reference: generateReference('RNT'),
    },
    {
      id: 'tx_6',
      type: 'Bills',
      title: 'MTN Airtime',
      amount: -2000,
      status: 'Completed',
      date: new Date(now.getTime() - 18 * 24 * 60 * 60 * 1000).toISOString(),
      reference: generateReference('BIL'),
    },
    {
      id: 'tx_7',
      type: 'Bills',
      title: 'DSTV Compact Plus',
      amount: -12500,
      status: 'Completed',
      date: new Date(now.getTime() - 20 * 24 * 60 * 60 * 1000).toISOString(),
      reference: generateReference('BIL'),
    },
    {
      id: 'tx_8',
      type: 'Diaspora',
      title: 'Transfer to Sarah Smith',
      amount: -155000, // $100 * 1550
      status: 'Completed',
      date: new Date(now.getTime() - 25 * 24 * 60 * 60 * 1000).toISOString(),
      reference: generateReference('TRF'),
    },
  ]

  const transfers = [
    {
      id: 'trf_1',
      sourceCurrency: 'USD',
      sourceAmount: 50,
      ngnAmount: 77500,
      recipientName: 'John Doe',
      bankName: 'GTBank',
      accountNumber: '0123456789',
      fee: 775,
      exchangeRate: 1550,
      status: 'Completed',
      date: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000).toISOString(),
      reference: transactions[2].reference,
    },
    {
      id: 'trf_2',
      sourceCurrency: 'USD',
      sourceAmount: 100,
      ngnAmount: 155000,
      recipientName: 'Sarah Smith',
      bankName: 'Access Bank',
      accountNumber: '0987654321',
      fee: 1550,
      exchangeRate: 1550,
      status: 'Completed',
      date: new Date(now.getTime() - 25 * 24 * 60 * 60 * 1000).toISOString(),
      reference: transactions[7].reference,
    },
  ]

  const properties = [
    {
      id: 'prop_1',
      address: 'Apt 4B, Ikota Villa Estate, Lekki',
      type: 'Apartment',
      monthlyRent: 350000,
      role: 'Tenant',
      landlordName: 'Chief Ojo',
      nextDueDate: new Date(
        now.getTime() + 345 * 24 * 60 * 60 * 1000,
      ).toISOString(), // ~11 months from now
    },
    {
      id: 'prop_2',
      address: 'Block 2, Sunshine Estate, Surulere',
      type: 'Commercial',
      monthlyRent: 150000,
      role: 'Landlord',
      tenantName: 'Ade Bakery Ltd',
      nextDueDate: new Date(
        now.getTime() + 15 * 24 * 60 * 60 * 1000,
      ).toISOString(),
    },
  ]

  const maintenanceRequests = [
    {
      id: 'req_1',
      propertyId: 'prop_1',
      issueType: 'Plumbing',
      description:
        'Leaking pipe under the kitchen sink causing water damage to the cabinets.',
      urgency: 'High',
      status: 'In Progress',
      createdAt: new Date(
        now.getTime() - 2 * 24 * 60 * 60 * 1000,
      ).toISOString(),
    },
    {
      id: 'req_2',
      propertyId: 'prop_2',
      issueType: 'Electrical',
      description: 'Flickering lights in the main hall, possible wiring issue.',
      urgency: 'Medium',
      status: 'Pending',
      createdAt: new Date(
        now.getTime() - 5 * 24 * 60 * 60 * 1000,
      ).toISOString(),
    },
    {
      id: 'req_3',
      propertyId: 'prop_1',
      issueType: 'Appliance',
      description: 'AC unit in the master bedroom is blowing warm air.',
      urgency: 'Low',
      status: 'Completed',
      createdAt: new Date(
        now.getTime() - 30 * 24 * 60 * 60 * 1000,
      ).toISOString(),
    },
  ]

  return {
    user,
    campaigns,
    transactions,
    transfers,
    properties,
    maintenanceRequests,
  }
}
